import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function CustomerAutocomplete({ value, onChange, testid = "customer-input", className = "" }) {
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const boxRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/customers/suggest", { params: { q: value || "" } });
        setSuggestions(data);
      } catch (e) { setSuggestions([]); }
    }, 200);
    return () => clearTimeout(t);
  }, [value]);

  useEffect(() => {
    const onClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const filtered = suggestions.filter((s) => s.toLowerCase() !== (value || "").toLowerCase());

  return (
    <div className="relative" ref={boxRef}>
      <Input
        data-testid={testid}
        className={className}
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder="Type customer name"
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div
          className="absolute z-50 left-0 right-0 mt-1 bg-white border border-slate-200 rounded-sm shadow-lg max-h-60 overflow-auto"
          data-testid="customer-suggestions"
        >
          {filtered.map((s) => (
            <button
              type="button" key={s}
              className="w-full text-left px-4 py-3 hover:bg-sky-50 text-slate-800 border-b border-slate-100 last:border-0"
              onClick={() => { onChange(s); setOpen(false); }}
              data-testid={`suggestion-${s}`}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
